<template>
    <figure class="slide__figure" v-if="slide.Image?.ImageUrl">
      <picture>
        <source
            media="(min-width: 1441px)"
            :srcset="`${slide.Image?.ImageUrl}?height=200&format=webp&quality=80`"
            type="image/webp" />
        <source
            media="(min-width: 1025px)"
            :srcset="`${slide.Image?.ImageUrl}?height=335&format=webp&quality=80`"
            type="image/webp" />
        <source
            media="(min-width: 391px)"
            :srcset="`${slide.Image?.ImageUrl}?height=450&format=webp&quality=80`"
            type="image/webp" />
        <source
            media="(max-width: 390px)"
            :srcset="`${slide.Image?.ImageUrl}?height=160&format=webp&quality=80`"
            type="image/webp" />
        <img :src="slide.Image?.ImageUrl" :alt="slide.Image?.AlternativeText" loading="lazy" />
      </picture>
    </figure>
    <div class="slide__content">
        <header class="header">
            <div class="title h5">{{ slide.Title }}</div>
        </header>

        <div class="body">
            {{ slide.Description }}
        </div>
    </div>
</template>

<script setup lang="ts">
import { ISlide } from '../interface/card-carousel.model';

defineProps<{
    slide: ISlide;
}>();
</script>
